import { Injectable } from '@angular/core';
import { APP } from "./../constants";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { IEmpresa, IResolution } from '@app/admin/views/empresa-form/empresa-form.type';
import { TaxDetail, TypeDocuments, TypeLiabilities, TypeOperation } from '@app/admin/views/empresa-form/empresa-form.config';

@Injectable({
    providedIn: 'root'
})

export class DianService {
    apiUrl = APP.ApiDianEndpoind;
    apiKey = APP.ApiKey;
    headers: HttpHeaders

    typeOperation = TypeOperation;
    typeDocuments = TypeDocuments;
    typeLiabilities = TypeLiabilities;
    taxDetail = TaxDetail;

    constructor(private _http: HttpClient) {
        this.headers = new HttpHeaders({
            'x-api-key': this.apiKey,
        });
    }

    postEmpresa(empresa: IEmpresa): Observable<any> {
        return this._http.post(`${this.apiUrl}company`, empresa, { headers: this.headers });
    }

    getEmpresaById(id: number): Observable<any> {
        return this._http.get(`${this.apiUrl}company/${id}`, { headers: this.headers });
    }

    putEmpresa(id: number, empresa: IEmpresa): Observable<any> {
        return this._http.put(`${this.apiUrl}company/${id}`, empresa, { headers: this.headers });
    }

    getTypeDocuments(): Observable<any> {
        return this._http.get(`${this.apiUrl}typeDocuments/list`);
    }
    gettypeOperation(): Observable<any> {
        return this._http.get(`${this.apiUrl}typeOperations/list`);
    }
    gettypeLiabilities(): Observable<any> {
        return this._http.get(`${this.apiUrl}typeLiability/list`);
    }
    gettaxDetail(): Observable<any> {
        return this._http.get(`${this.apiUrl}taxDetail/list`);
    }
    getLenguage(): Observable<any> {
        return this._http.get(`${this.apiUrl}lenguage/list`);
    }

    getResolution(idComp: number): Observable<any> {
        return this._http.get(`${this.apiUrl}api/resolution?identification_number=${idComp}`);
    }

    postSoftware(data: any):Observable<any> {
         return this._http.post(`${this.apiUrl}software`, data);
    }

    putSoftware(data: any, id: number):Observable<any> {
        return this._http.put(`${this.apiUrl}software/${id}`, data);
   }

    postResolucion(data: IResolution): Observable<any> {
        return this._http.post(`${this.apiUrl}api/resolution`, data);
    }

    putResolucion(data: IResolution, id: number): Observable<any> {
        return this._http.put(`${this.apiUrl}api/resolution/${id}`, data);
    }

    postGenerarCertificado(data: any): Observable<any>{
        return this._http.post(`${this.apiUrl}certificate`, data, { headers: this.headers });
    }

}